module.exports = __webpack_public_path__ + "img/mesa_el_s.1f7bd6c6.png";